<template>
  <div v-if="sortedAlbums.length" class="albums-wall has-albums">
    <div v-for="album of sortedAlbums" :key="album.id">
      <router-link :to="viewAlbum(album)">
        <div class="album-thumbnail">
          <div><img :src="album.coverPageImageUrl" /></div>
          <div class="name">{{album.name}}</div>
        </div>
      </router-link>
    </div>
  </div>
  <div v-else class="albums-wall">
    No public albums yet!
  </div>
</template>

<script>
import { viewAlbum } from '../utils/routing'
import albumCover from '../../public/images/album-cover.png'
export default {
  props: ['albums', 'pages'],
  computed: {
    sortedAlbums() {
      const copy = this.albums.slice()
      copy.sort((a, b) => a.name.localeCompare(b.name))
      const albumsWithCoverPageImageUrl = copy.map(x => ({ ...x, coverPageImageUrl: x.coverPageId ? this.pages.find(z => z.id === x.coverPageId).thumbnailUrl : albumCover }))
      return albumsWithCoverPageImageUrl
    },
  },
  methods: {
    viewAlbum,
  },
}
</script>

<style lang="stylus" scoped>
.albums-wall
  display flex
  flex-wrap wrap
  margin-top 20px


  // I got the idea of negative margins from here:
  // https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Flexible_Box_Layout/Mastering_Wrapping_of_Flex_Items
  // Search for "Creating gutters between items"
  &.has-albums
    margin-left -40px
    margin-bottom -20px

  .album-thumbnail
    margin-left 40px
    margin-bottom 20px
    text-align center

    img
      max-width 100px
</style>
